import { template as template_73e3847a779849db8cef8d9214d37f2d } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { t } from 'ember-intl';
import BsForm from 'eflex/components/bs-form';
import { findBy } from '@eflexsystems/ember-composable-helpers';
import Portal from 'ember-stargate/components/portal';
export default class BiPanelUniqueSerial extends Component {
    @tracked
    isDisplayed = false;
    OPTIONS = [
        {
            label: 'useUniqueSerialNumbers',
            value: false
        },
        {
            label: 'useTotalCycles',
            value: true
        }
    ];
    constructor(){
        super(...arguments);
        this.isDisplayed = this.args.useTotalCycles.length > 0;
        this.args.initParam('useTotalCycles', this.args.useTotalCycles);
    }
    @action
    onChange(useTotalCycles) {
        this.args.updateParam('useTotalCycles', useTotalCycles.value);
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_73e3847a779849db8cef8d9214d37f2d(`
    <Portal @target="filter-fields">
      <div class="use-unique-serials-radio-button d-flex justify-content-center" ...attributes>
        <BsForm as |form|>
          <form.element
            @controlType="radio-group"
            @options={{this.OPTIONS}}
            @value={{findBy "value" @useTotalCycles this.OPTIONS}}
            @optionLabelPath="label"
            @onChange={{this.onChange}}
          as |el|>
            <el.control @inline={{true}} as |opt|>
              {{t opt}}
            </el.control>
          </form.element>
        </BsForm>
      </div>
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    ;
}
